import React from 'react';

const LogoCalendar = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#0EA5E9"/>
    <rect x="10" y="14" width="28" height="24" rx="4" fill="white"/>
    <path d="M10 20H38" stroke="#0EA5E9" strokeWidth="2"/>
    <rect x="14" y="10" width="20" height="6" rx="2" fill="#0EA5E9"/>
    <circle cx="18" cy="27" r="2" fill="#0EA5E9"/>
    <circle cx="24" cy="27" r="2" fill="#0EA5E9"/>
    <circle cx="30" cy="27" r="2" fill="#0EA5E9"/>
    <circle cx="18" cy="33" r="2" fill="#0EA5E9"/>
    <circle cx="24" cy="33" r="2" fill="#0EA5E9"/>
    <circle cx="30" cy="33" r="2" fill="#0EA5E9"/>
  </svg>
);

export default LogoCalendar;
